import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  AI_PROSPECT_PROFILE,
  AI_PROFILE_FORM_TABLE,
} from "../../../Utils/Constants";
import { useNavigate } from "react-router-dom";
const NewAiProfileModal = ({
  openTableDrawer,
  setOpenTableDrawer,
  value,
  isTabletPortrait,
}) => {
  const [selected, setSelected] = useState("lead");
  const navigate = useNavigate();

  return (
    <>
      <Slide
        direction="left"
        in={openTableDrawer}
        mountOnEnter
        unmountOnExit
        className="aip-filter-mb-slide"
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "#fff",
            display: "flex",
            flexDirection: "column",
            pb: 20,

          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: 2,
              display: "flex",
              flexDirection: "column",
            alignItems:isTabletPortrait ? "center" : ""

            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography fontSize="14px" fontWeight={600}>
                New AI Profile
              </Typography>

              <IconButton
                size="small"
                onClick={() => setOpenTableDrawer(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Subtitle */}
            <Typography fontSize="12px" color="#666" mb={2}>
              Select what type of AI profile you wish to create
            </Typography>

            {/* Radio Options */}
            <RadioGroup
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
            >
              <FormControlLabel
                value="lead"
                control={
                  <Radio
                    sx={{
                      color: "#d32f2f",
                      "&.Mui-checked": { color: "#d32f2f" },
                    }}
                  />
                }
                label={
                  <Typography fontSize="13px" color="#d32f2f">
                    Lead Profile
                  </Typography>
                }
              />

              <FormControlLabel
                value="prospect"
                control={
                  <Radio
                    sx={{
                      color: "#d32f2f",
                      "&.Mui-checked": { color: "#d32f2f" },
                    }}
                  />
                }
                label={
                  <Typography fontSize="13px" color="#d32f2f">
                    Prospect Profile
                  </Typography>
                }
              />
            </RadioGroup>

            {/* Footer Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                mt: 3,
              }}
            >
              <Button
                variant="text"
                sx={{
                  fontSize: "12px",
                  textTransform: "none",
                  color: "#000",
                }}
                onClick={() => setOpenTableDrawer(false)}
              >
                Cancel
              </Button>

              <Button
                onClick={() => {
                  setOpenTableDrawer(false);

                  if (selected === "lead") {
                    navigate(AI_PROFILE_FORM_TABLE);
                  } else {
                    navigate(AI_PROSPECT_PROFILE);
                  }
                }}
                variant="contained"
                sx={{
                  fontSize: "12px",
                  textTransform: "none",
                  bgcolor: "#d32f2f",
                  "&:hover": { bgcolor: "#b71c1c" },
                  borderRadius: "4px",
                  px: 2,
                }}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Box>
      </Slide>
    </>
  );
};
export default NewAiProfileModal;
